import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import SecondSectionStore from '@src/pages/main/sections/second-section/store';
// import CountDown from '@src/business-components/count-down';
import Link from '@src/components/link';
import locales from './locales';

const styles = require('./index.less');

/**
 * SecondSection
 * @param store {SecondSectionStore}
 * @returns {JSX.Element}
 * @constructor
 */
const SecondSection = ({ store }) => {
  store.use();

  return (
    <div className={cx(styles.secondSectionRoot, store.isActive && styles.isActive)}>
      <div className={styles.content}>
        <div className={styles.slogan} />
        <div className={styles.xiaozi} />

        <Link
          className={styles.btn}
          onClick={() => {
            store.openCompetitionUrl();
          }}
        >
          {locales.viewDetailsBtn}
        </Link>
      </div>
    </div>
  );
};

export default wrapStore(SecondSection, SecondSectionStore);
